import { Pipe, PipeTransform } from '@angular/core';
import { ReportTableColumn } from '../models/report-table-column.model';

@Pipe({
  name: 'cellValueFormatter',
  pure: true,
})
export class CellValueFormatterPipe implements PipeTransform {
  transform(element: any, column: ReportTableColumn): string {
    const value = element[column.propertyName];

    // Currency formatting
    if (column.format === 'currency') {
      return this.formatCurrency(value);
    }

    // Percent formatting
    if (column.format === 'percent') {
      return this.formatPercent(value);
    }

    // Customer name detail formatting
    if (column.columnName === 'customer-name-detail') {
      return this.formatCustomerNameDetail(value, element['Customer Number']);
    }

    // Boolean to Y/N conversion
    if (this.isBooleanColumn(column.columnName)) {
      return this.formatBooleanValue(value);
    }

    // Default: return the raw value
    return value;
  }

  private formatCurrency(value: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
  }

  private formatPercent(value: number): string {
    return (
      new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value) + '%'
    );
  }

  private formatCustomerNameDetail(
    customerName: string,
    customerNumber: string,
  ): string {
    return `${customerName} (${customerNumber})`;
  }

  private formatBooleanValue(value: boolean): string {
    return value ? 'Y' : 'N';
  }

  private isBooleanColumn(columnName: string): boolean {
    return (
      columnName === 'catch-wght-ind' || columnName === 'proprietary-product'
    );
  }
}
